import { Button } from '@grubhubprod/gh-cookbook-react/dist';
import React from 'react';

import { Flex, Loader, Stack } from '@grubhubprod/gh-cookbook-react';

export function FetchingState(): JSX.Element {
  return (
    <Button
      disabled
      variant="tertiary"
      buttonSize="medium"
      className="tableActionButtons"
    >
      <Flex alignItems="center" className="ellipsisOverflow">
        <Stack x="xx-sm">Downloading pdf</Stack>
        <Loader size="sm" />
      </Flex>
    </Button>
  );
}
